import { Subscribable, UNKNOWN } from './Subscribable.js';
import { withTransaction } from './Transaction.js';
/**
 * An observable object type that manages its subscriptions and allows manually setting its value to notify subscribers.
 * Equivalent to Subject in RxJs.
 */
export class Holder extends Subscribable {
    // Note: new Holder<NonUndefinedType>(undefined) is not allowed but isn’t flagged, see https://github.com/microsoft/TypeScript/issues/44548
    constructor(value) {
        super();
        this.value = UNKNOWN;
        if (arguments.length > 0) {
            this.value = value;
        }
    }
    get() {
        return this.value;
    }
    set(value) {
        this.value = value;
        withTransaction(() => {
            this.changed();
        });
    }
}
